import React, { FC, useMemo } from 'react';
import { Category, DemandArea } from '../../../../lib/types/endUser';
import styles from '../SquareShadowHouseNew/index.module.scss';
import { ProgressBar } from '../ProgressBar';
import { parseJSON } from '../../../../lib/utils/helpers';
import { useContainerQuery } from '../../../../lib/hooks/endUserHooks/useContainerQuery';
import { EviNewHouseModelDesktop } from '../../../../components/EviNewHouseModel/components/EviNewHouseModelDesktop';
import { SmallDemandAreaHouse } from '../SmallDemandAreaHouse';

type Props = {
  handleTabClick: (index: number) => void;
  activeTab?: number;
  currentDemandArea: any;
  demandAreas: DemandArea[];
  onClickCategory: (category: Category) => void;
};

export const EviSquareHouse: FC<Props> = ({
  handleTabClick,
  activeTab,
  currentDemandArea,
  demandAreas,
  onClickCategory,
}) => {
  const { isOnlyTablet } = useContainerQuery();

  const demandAreaColor = useMemo(() => {
    return parseJSON(currentDemandArea.color);
  }, [currentDemandArea]);

  const bigSquareStyle = {
    transform: isOnlyTablet
      ? `translate(${Number(activeTab) % 2 ? -20 : 20}%, -${Math.floor(Number(activeTab) / 2) * 50 + (Number(activeTab) === 1 || Number(activeTab) === 0 ? 18 : 0)}%) scale(0.7)`
      : `translate(${(Number(activeTab) % 2) * -65 + (Number(activeTab) === 1 || Number(activeTab) === 3 ? 25 : 25)}%, -${Number(activeTab) === 0 || Number(activeTab) === 1 ? 2 : Math.floor(Number(activeTab) / 2) * 44}%)`,
  };

  const handleKeyDownCategory = (
    event: React.KeyboardEvent<HTMLDivElement>,
    category: Category,
  ) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClickCategory(category);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>, index: number) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleTabClick(index);
    }
  };

  const activeId = demandAreas[Number(activeTab)]?.id;

  return (
    <div className={styles.squareSectionContainer}>
      <div
        className={styles.squareContainer}
        style={{ backgroundColor: demandAreaColor.value }}
      >
        <SmallDemandAreaHouse
          onAreaClick={handleTabClick}
          onClickCategory={onClickCategory}
          demandAreaColor={demandAreaColor.value}
          demandAreas={demandAreas}
          currentDemandArea={currentDemandArea}
        />
        <div className={styles.container} style={bigSquareStyle}>
          <EviNewHouseModelDesktop
            demandAreas={demandAreas}
            handleKeyDownCategory={handleKeyDownCategory}
            handleKeyDown={handleKeyDown}
            onClickCategory={onClickCategory}
            activeId={activeId}
          />
        </div>
      </div>
      <ProgressBar currentDemandArea={currentDemandArea} />
    </div>
  );
};
